// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"style_widgetContainer__FQlEQ","disclaimer":"style_disclaimer__E3Rr9"};